import React from "react";

import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";

import { NotificationSnackbarProps } from "./types";

export const NotificationSnackbar = ({
    open,
    title,
    description,
    severity,
    onClose,
    autoHideDuration,
    toastKey,
}: NotificationSnackbarProps) => (
    <Snackbar
        key={toastKey}
        open={open}
        autoHideDuration={autoHideDuration}
        onClose={(_event, reason) => {
            // Клик мимо тоста его не закрывает — сообщение должно дожить до таймера.
            if (reason === "clickaway") return;
            onClose();
        }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
        <Alert severity={severity} onClose={onClose}>
            <AlertTitle>{title}</AlertTitle>
            {description}
        </Alert>
    </Snackbar>
);

export { useNotificationSnackbar } from "./useNotificationSnackbar";
export type { UseNotificationSnackbarReturn } from "./useNotificationSnackbar";
export type { NotificationSeverity, NotificationSnackbarProps } from "./types";
